import { gql } from '@apollo/client';

/** One team member row on the CMS Training tab. */
export const TRAINING_MEMBER_FIELDS = `
    teamMemberId
    name
    email
    role
    recordId
    sent
    sentAt
    openedAt
    url
    shortUrl
    progress {
        total
        todo
        learning
        needHelp
        gotIt
        na
    }
`;

/**
 * A team member's manual as rendered — the published template merged with the
 * member's module statuses plus the comment thread. `sections` is a JSON
 * scalar: [{ key, title, modules: [{ id, title, videoUrl?, guides, status }] }].
 */
export const TRAINING_MANUAL_FIELDS = `
    recordId
    teamMemberName
    businessName
    version
    intro
    sections
    progress {
        total
        todo
        learning
        needHelp
        gotIt
        na
    }
    comments {
        _id
        moduleId
        authorType
        authorName
        text
        parentId
        createdAt
    }
`;

/** `definition` is a JSON scalar: { version, intro, sections: [{ key, title, modules }] }. */
export const TRAINING_TEMPLATE_FIELDS = `
    definition
    customised
    published
    revision
    publishedAt
    seedVersion
`;

/**
 * PUBLIC (no auth) — the training token in the URL is the authorization. The
 * Apollo refresh-on-UNAUTHENTICATED link never fires for these because the
 * resolver is unguarded.
 */
export const GET_TRAINING_BY_TOKEN_QUERY = gql`
    query GetTrainingByToken($token: String!) {
        getTrainingByToken(token: $token) {
            ${TRAINING_MANUAL_FIELDS}
        }
    }
`;

/** Staff (@Auth) — the CMS-editable master training manual (singleton). */
export const GET_TRAINING_TEMPLATE_QUERY = gql`
    query GetTrainingTemplate {
        getTrainingTemplate {
            ${TRAINING_TEMPLATE_FIELDS}
        }
    }
`;

/** Staff (@Auth) — every team member of a business with their training state. */
export const GET_TRAINING_FOR_BUSINESS_QUERY = gql`
    query GetTrainingForBusiness($businessId: String!) {
        getTrainingForBusiness(businessId: $businessId) {
            ${TRAINING_MEMBER_FIELDS}
        }
    }
`;

/** Staff (@Auth) — one team member's manual as they see it, for the CMS detail view. */
export const GET_TRAINING_RECORD_QUERY = gql`
    query GetTrainingRecord($teamMemberId: String!) {
        getTrainingRecord(teamMemberId: $teamMemberId) {
            ${TRAINING_MANUAL_FIELDS}
        }
    }
`;
